module.exports = __webpack_public_path__ + "static/media/logo.734bad83.svg";